import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import tokenManager from "@common/utils/src/auth/TokenManager";

export const useAuthToken = () => {
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

    useEffect(() => {
        if (isAuthenticated) {
            tokenManager.setTokenProvider((opts = {}) => getAccessTokenSilently({ ...opts }));
        } else {
            tokenManager.setTokenProvider(null);
        }
    }, [isAuthenticated, getAccessTokenSilently]);

    return { tokenManager };
};

export default useAuthToken;
